import { object, string } from 'yup';
import i18n from 'config/i18n';

const fullNameRequired: string = i18n.t('user:fullNameRequired');
const emailRequired: string = i18n.t('user:emailRequired');

const currentPasswordRequired: string = i18n.t('user:currentPasswordRequired');
const newPasswordRequired: string = i18n.t('user:newPasswordRequired');

export const AccountSchema = object().shape({
  full_name: string().trim().required(fullNameRequired),
  job_title: string().trim(),
  email_address: string().required(emailRequired).email(emailRequired),
  department_id: string().nullable(true),
  location_id: string().nullable(true),
});

export const ChangePasswordSchema = object().shape({
  current_password: string().min(6).max(50).required(currentPasswordRequired),
  new_password: string().min(6).max(50).required(newPasswordRequired),
});

export interface IAccountValues {
  full_name: string;
  job_title: string;
  email_address: string;
  department_id?: string;
  location_id?: string;
}

export interface IChangePasswordValues {
  current_password: string;
  new_password: string;
}
